function hideAllMultiselectorsEvent(e) {
  if (!e.target.closest('[data-selector="multiselector"]')) {
    hideAllMultiselectors();
    document.removeEventListener('click', hideAllMultiselectorsEvent);
    document.body.dataset.multiselectorDisableEvent = "";
  }
}

function hideAllMultiselectors() {
  var multiselectList = document.querySelectorAll('[data-selector="multiselector"]');
  var multiselectListLength = multiselectList.length;
  for (var index = 0; index < multiselectListLength; index++) {
    var element = multiselectList[index];
    var option = element.querySelector('[data-selector="multiselector__options"]');
    option.classList.remove('active');
  }
}

function multiselectRender() {
  var multiselectList = document.querySelectorAll('[data-selector="multiselector"]');
  var multiselectListLength = multiselectList.length;
  for (var index = 0; index < multiselectListLength; index++) {
    var element = multiselectList[index];
    bindMultiselectEvents(element);
  }
}

function bindMultiselectEvents(element) {
  var clickableElement = element.querySelector('[data-selector="multiselector__select-over-select"]');
  if (clickableElement) {
    element.addEventListener('click', function (event) {
      if (event.target == clickableElement) {
        multiselectClicked(element);
      }
    });
  }
  bindMultiselectOptionsChangeEvent(element);
  bindMultiselectOptionsClickEvent(element);
}

function bindMultiselectOptionsChangeEvent(multiselectElement) {
  var optionList = multiselectElement.querySelectorAll('[data-selector="multiselector__option-checkbox"]');
  var optionListLength = optionList.length;
  for (var index = 0; index < optionListLength; index++) {
    var element = optionList[index];
    bindMultiselectOptionChangeEvent(multiselectElement, element, optionList);
  }
}

function bindMultiselectOptionsClickEvent(multiselectElement) {
  var optionList = multiselectElement.querySelectorAll('[data-actor="multiselector__select-and-close"]');
  var basicOption = multiselectElement.querySelector('[data-selector="multiselector__select-option"]');
  var optionListLength = optionList.length;
  var clickAndCloseSelect = multiselectElement.querySelector('[data-selector="multiselector__select-click-and-close"]');
  var flag = multiselectElement.querySelector('[data-selector="multiselector__select-wrapper"] img');
  if (clickAndCloseSelect) {
    for (var index = 0; index < optionListLength; index++) {
      var option = optionList[index];
      option.addEventListener('click', function (event) {
        hideAllMultiselectors();
        flag.src = this.querySelector('img').src;
        basicOption.innerText = this.innerText;
        clickAndCloseSelect.value = this.dataset.value;
      });
    }
  }
}

function bindMultiselectOptionChangeEvent(multiselectElement, option, optionList) {
  var input = multiselectElement.querySelector('[data-selector="multiselector__option-text"]');
  var basicOption = multiselectElement.querySelector('[data-selector="multiselector__select-option"]');
  option.addEventListener('change', function (event) {
    updateBasicOptionValue(optionList, input, basicOption);
    tryToTextReveal(option, input);
  });
  if (input) {
    input.addEventListener('change', function (event) {
      updateBasicOptionValue(optionList, input, basicOption);
    });
  }
}

function tryToTextReveal(option, input) {
  if (option.id === "thankyou_myStoreOther" || option.id === "thankyou_hearingOther") {
    input.closest('[data-selector="multiselector__option-label"]').classList.toggle('active');
  }
}

function updateBasicOptionValue(optionList, input, basicOption) {
  var checkedNameList = getCheckedOptionsText(optionList);
  basicOption.innerText = (checkedNameList.length ? checkedNameList.join(', ') : basicOption.dataset.defaultText);
  if (input) {
    basicOption.innerText += ' ' + input.value;
  }
}

function getCheckedOptionsText(optionList) {
  var checkedNameList = [];
  var optionListLength = optionList.length;
  for (var index = 0; index < optionListLength; index++) {
    var element = optionList[index];
    if (element.checked) {
      checkedNameList.push(element.closest('[data-selector="multiselector__option-label"]').innerText);
    }
  }
  return checkedNameList;
}

function multiselectClicked(element) {
  var option = element.querySelector('[data-selector="multiselector__options"]');
  var isActivated = option.classList.toggle('active');
  if (isActivated && !document.body.dataset.multiselectorDisableEvent) {
    document.addEventListener('click', hideAllMultiselectorsEvent);
    document.body.dataset.multiselectorDisableEvent = 1;
  }
  else if (!isActivated && document.body.dataset.multiselectorDisableEvent) {
    document.removeEventListener('click', hideAllMultiselectorsEvent);
    document.body.dataset.multiselectorDisableEvent = "";
  }
}

multiselectRender();
